import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { BusinessModel } from '../customer-modals/business-modal';
import { CUSTOMER_MENU_ITEMS } from '../customer-service.service';
import { filter } from 'rxjs/operators';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-admin-hor-menu',
  standalone: true,
  imports: [CommonModule, RouterModule,

    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './admin-hor-menu.component.html',
  styleUrls: ['./admin-hor-menu.component.scss']
})
export class AdminHorMenuComponent implements OnInit {

  role: any;
  MemberShipType: any;
  filterData: any = {};
  searchText: string = '';
  selectedName !: string;
  selectedItem: CUSTOMER_MENU_ITEMS = "plan";
  navBarList = [
    { item: "plan", name: "Plan", path: '/user-management/plan', cateogory: "left" },
    { item: "user", name: "Users", path: '/user-management/user' , cateogory: "left"},
    { item: "interaction", name: "Interaction Credits", path: '/user-management/interaction', cateogory: "left" },
    { item: "jobs", name: "Job/Candidate Slots", path: '/user-management/jobs', cateogory: "left" },
    // Business Jobs and Business Candidates moved to standalone Job Center and Talent Center modules
    // { item: "businessApplicants", name: "Business Applicants", path: '/user-management/business-applicants', cateogory: "right" },
    { item: "workSpace", name: "Workspaces", path: '/user-management/workSpace', cateogory: "right" },
    { item: "contacts", name: "Members", path: '/user-management/contacts', cateogory: "right" },
    { item: "network", name: "Member Networks", path: '/user-management/network', cateogory: "right" },
    { item: "businessContacts", name: "Business", path: '/user-management/businessContacts', cateogory: "right" },
    { item: "businessNetworks", name: "Business Networks", path: '/user-management/businessNetworks', cateogory: "right" },
    { item: "publishSettings", name: "Publish Settings", path: '/user-management/publishSettings', cateogory: "right" },
  ];


  constructor(private router: Router, private route: ActivatedRoute) { }


  @Input() businessData: BusinessModel;
  currentPath: string;
  selectedTab: string = "plan";

  ngOnInit(): void {
    this.selectedTab = "plan";

    // Check current route on init
    let currentElement: any = this.navBarList.find(tab => this.router.url.includes(tab.path));
    if (currentElement) {
      this.selectedTab = currentElement.item;
    }

    // Listen to navigation events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
       console.log('NavigationEnd fired:', event);
      let element: any = this.navBarList.find(tab => this.router.url.includes(tab.path));
      if (element) {
        this.selectedTab = element.item;
        if (element.cateogory === "left") {
          this.scrollLeft();
        } else if (element.cateogory === "right") {
          this.scrollRight();
        }
      }
    });
  }



  // routeTo(item) {
  //   this.selectedItem = item.item;
  //   this.filterData = {};
  //   this.searchText = '';
  //   this.router.navigate([item.path]);
  // }
routeTo(item: any) {
  this.selectedItem = item.item;
  this.filterData = {};
  this.searchText = '';

  if (this.selectedTab === item.item) {
    // Same tab clicked again — force a real reload of the routed component
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([item.path]);
    });
  } else {
    this.router.navigate([item.path]);
  }
}

  get isFreeOrTeam() {
    return this.MemberShipType === GigsumoConstants.FREE_PLAN;
  }



  canShowMenu(menuItem: any): boolean {
    if (!this.businessData) {
      return false; // If businessData is not loaded yet, hide menu items
    }

    const { role, businessOwner } = this.businessData;  // Extract role and owner ID
    const userId = localStorage.getItem('userId');
    const isOwner = businessOwner === userId;

    const superAdminMenus = ["businessApplicants", "publishSettings"];
    const restrictedForEmployees = ["businessContacts", "contacts"];

    // Only Super Admin or Business Owner can access super admin menus
    if (superAdminMenus.includes(menuItem.item)) {
      return role === 'SUPERADMIN' || isOwner;
    }

    // Employees cannot access restricted menus
    if (restrictedForEmployees.includes(menuItem.item)) {
      return role !== 'EMPLOYEE' && role !== 'ADMIN';
    }


    return true;  // Default: allow access
  }

  showChevron: boolean = true;
  showChevron1: boolean = true;
  onMouseEnter1() {
    // this.showChevron1 = true;
  }

  onMouseLeave1() {
    // this.showChevron1 = false;
  }

  scrollLeft() {
    const scrollContainer = document.getElementById('scrollContainer1');
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: -400, behavior: 'smooth' });
    }
  }

  scrollRight() {
    const scrollContainer = document.getElementById('scrollContainer1');
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: 400, behavior: 'smooth' });
    }
  }
  onMouseEnter() {
    // this.showChevron = true;
  }

  onMouseLeave() {
    // this.showChevron = false;
  }

}
